type Handler<T> = (data: T) => void;
export const createObservable = <T>() => {
    const listeners = new Set<Handler<T>>();

    const subscribe = (handler: Handler<T>) => {
        listeners.add(handler);
        return () => unsubscribe(handler);
    };
    const unsubscribe = (handler: Handler<T>) => {
        listeners.delete(handler);
    };

    const notify = (data: T) => {
        listeners.forEach((listener) => listener(data));
    };
    const getListenersCount = () => listeners.size;
    const clearListeners = () => listeners.clear();
    return { subscribe, unsubscribe, notify, getListenersCount, clearListeners };
};
